import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 0h24v24H0z" }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M19 10.5a8.5 8.5 0 1 0-17 0 8.5 8.5 0 0 0 17 0Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.329 7.172A3.99 3.99 0 0 0 10.5 6a3.99 3.99 0 0 0-2.828 1.172M16.611 16.61l4.243 4.243"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search"}) } }